module.exports = __webpack_public_path__ + "static/play-with-a-friend-meta-652cbf2eadffffd10a6a1439b13416a8.jpg";